import { render, staticRenderFns } from "./VideoResults.vue?vue&type=template&id=63419cd7&"
import script from "./VideoResults.vue?vue&type=script&lang=js&"
export * from "./VideoResults.vue?vue&type=script&lang=js&"
import style0 from "./VideoResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports